<div class="btn-loader">
    <span></span>
    <span></span>
    <span></span>
</div>